// Tekster for pipeline pakke 2 (pipeline-visning): kortene, neste steg,
// råtning, slippsonene, hurtigfiltre og stadieporten.
export const norwegianPipelineViewMessages = {
  crm: {
    tasks: {
      type: {
        label: "Type",
        none: "Vanlig oppgave",
        call: "Ring",
        meeting: "Møte",
        site_visit: "Befaring",
        email: "E-post",
        task: "Oppgave",
        revisit: "Revisit",
        review: "Be om anmeldelse",
        billing: "Fakturering",
      },
    },
    deals: {
      next: {
        title: "Hva er neste steg?",
        description:
          "Hver mulighet trenger et neste steg. Hva gjør vi, og når?",
        what: "Hva gjør vi?",
        when: "Når?",
        plan: "Planlegg neste steg",
        skip: "Hopp over",
        open_steps: "Åpne steg",
        complete: "Fullfør %{title}",
        completed: "Fullført: %{title}",
        planned: "Neste steg er planlagt",
        need_title: "Skriv hva neste steg er.",
        need_date: "Velg en dato.",
        missing: "Planlegg et neste steg før du lagrer.",
        none: "Ingen neste steg",
        today: "i dag",
        overdue: "forfalt %{smart_count} d",
        status_today: "I dag",
        status_overdue: "Forfalt",
        status_future: "Fremtidig dato",
        status_none: "Ingen neste steg",
        box_title: "Neste steg",
        default_title: "Neste steg",
        fields_title: "Neste steg",
        fields_help:
          "En åpen mulighet utenom Lead inn må ha en åpen oppgave med dato.",
      },
      card: {
        silent:
          "Stille i %{smart_count} dag |||| Stille i %{smart_count} dager",
        offer_valid: "Tilbud gyldig til %{date}",
        per_month: "%{amount}/mnd",
        owner: "Eier: %{name}",
        no_owner: "Uten eier",
        rotting: "Råtner",
        actions: "Handlinger for %{name}",
      },
      column: {
        summary: "%{count} · %{amount}",
        weighted: "Vektet: %{amount}",
      },
      sort: {
        label: "Sortering",
        action: "Behov for handling",
        value: "Verdi",
        expected_close: "Forventet avslutning",
        days_in_stage: "Dager i stadiet",
      },
      drop: {
        won: "Vunnet",
        lost: "Tapt",
        archive: "Arkiver",
        hint: "Slipp her",
      },
      moved: "Flyttet til %{stage}.",
      archived_done: "%{name} er arkivert",
      quick: {
        label: "Hurtigfiltre",
        mine: "Mine",
        owner: "Eier",
        all_owners: "Alle eiere",
        no_next_step: "Ingen neste steg",
        overdue: "Forfalt",
        rotting: "Råtner",
        high_value: "Høy verdi",
        subscription: "Abonnement",
        clear: "Nullstill filter",
        no_matches: "Ingen muligheter passer filteret.",
      },
      gate: {
        title: "Flytt til %{stage}",
        description: "Fyll inn det som mangler for stadiet.",
        confirm: "Flytt",
        file: "Tilbud (fil)",
        file_note: "Tilbud",
        meeting_date: "Møtedato",
        meeting_title: "Møte",
        missing_field: "Fyll inn %{field}.",
        budget_help: "For eksempel 50–100 000 kr, eller «Ukjent».",
      },
      owner: {
        title: "Bytt eier",
        description: "Hvem har ansvaret for %{name}?",
        save: "Lagre",
        changed: "Eier er endret",
      },
      note: {
        title: "Notat på %{name}",
        save: "Lagre notatet",
        saved: "Notatet er lagret",
      },
      disqualify: {
        title: "Diskvalifiser %{name}?",
        description:
          "Leaden var aldri en reell mulighet. Den forsvinner fra Lead inn.",
        confirm: "Diskvalifiser",
        done: "%{name} er diskvalifisert",
      },
      qualify: "Kvalifiser",
      reopen: {
        description:
          "Muligheten blir åpen igjen og havner i stadiet du velger.",
      },
      view_kanban: "Tavle",
      view_list: "Tabell",
      empty_pipeline:
        "Pipelinen er tom. Registrer en henvendelse, eller koble til et skjema.",
      new_lead: "Ny lead",
    },
    settings: {
      deals: {
        high_value: "Høy verdi fra (årsverdi)",
        high_value_help:
          "Grensen for hurtigfilteret «Høy verdi» på Pipeline. Tom skjuler filteret.",
      },
    },
    shortcuts: {
      group_pipeline: "Pipeline (kort i fokus)",
      pipeline_open: "Åpne mulighet",
      pipeline_next_step: "Neste steg",
      pipeline_move: "Neste / forrige stadium",
      pipeline_won: "Vunnet",
      pipeline_lost: "Tapt",
      pipeline_qualify: "Kvalifiser / diskvalifiser (Lead inn)",
      pipeline_owner: "Bytt eier",
      pipeline_note: "Notat",
      pipeline_tabs: "Faner: Åpne · Vunnet · Tapt",
    },
  },
  resources: {
    deals: {
      fields: {
        offer_valid_until: "Tilbud gyldig til",
        budget_range: "Budsjett",
        last_activity_at: "Siste aktivitet",
        next_step_title: "Neste steg",
        next_step_type: "Type",
        next_step_date: "Dato for neste steg",
      },
    },
    work_items: {
      fields: {
        task_type: "Type",
        deal_id: "Mulighet",
      },
    },
  },
};

export const englishPipelineViewMessages = {
  crm: {
    tasks: {
      type: {
        label: "Type",
        none: "Regular task",
        call: "Call",
        meeting: "Meeting",
        site_visit: "Site visit",
        email: "Email",
        task: "Task",
        revisit: "Revisit",
        review: "Ask for review",
        billing: "Billing",
      },
    },
    deals: {
      next: {
        title: "What's the next step?",
        description:
          "Every opportunity needs a next step. What do we do, and when?",
        what: "What do we do?",
        when: "When?",
        plan: "Plan next step",
        skip: "Skip",
        open_steps: "Open steps",
        complete: "Complete %{title}",
        completed: "Completed: %{title}",
        planned: "Next step planned",
        need_title: "Write what the next step is.",
        need_date: "Pick a date.",
        missing: "Plan a next step before saving.",
        none: "No next step",
        today: "today",
        overdue: "overdue %{smart_count} d",
        status_today: "Today",
        status_overdue: "Overdue",
        status_future: "Future date",
        status_none: "No next step",
        box_title: "Next step",
        default_title: "Next step",
        fields_title: "Next step",
        fields_help:
          "An open opportunity outside the inbox needs an open task with a date.",
      },
      card: {
        silent:
          "Silent for %{smart_count} day |||| Silent for %{smart_count} days",
        offer_valid: "Offer valid until %{date}",
        per_month: "%{amount}/mo",
        owner: "Owner: %{name}",
        no_owner: "No owner",
        rotting: "Rotting",
        actions: "Actions for %{name}",
      },
      column: {
        summary: "%{count} · %{amount}",
        weighted: "Weighted: %{amount}",
      },
      sort: {
        label: "Sort",
        action: "Needs action",
        value: "Value",
        expected_close: "Expected close",
        days_in_stage: "Days in stage",
      },
      drop: {
        won: "Won",
        lost: "Lost",
        archive: "Archive",
        hint: "Drop here",
      },
      moved: "Moved to %{stage}.",
      archived_done: "%{name} archived",
      quick: {
        label: "Quick filters",
        mine: "Mine",
        owner: "Owner",
        all_owners: "All owners",
        no_next_step: "No next step",
        overdue: "Overdue",
        rotting: "Rotting",
        high_value: "High value",
        subscription: "Subscription",
        clear: "Clear filter",
        no_matches: "No opportunities match the filter.",
      },
      gate: {
        title: "Move to %{stage}",
        description: "Fill in what the stage needs.",
        confirm: "Move",
        file: "Offer (file)",
        file_note: "Offer",
        meeting_date: "Meeting date",
        meeting_title: "Meeting",
        missing_field: "Fill in %{field}.",
        budget_help: "For example 50–100k, or “Unknown”.",
      },
      owner: {
        title: "Change owner",
        description: "Who is responsible for %{name}?",
        save: "Save",
        changed: "Owner changed",
      },
      note: {
        title: "Note on %{name}",
        save: "Save note",
        saved: "Note saved",
      },
      disqualify: {
        title: "Disqualify %{name}?",
        description:
          "The lead was never a real opportunity. It leaves the inbox.",
        confirm: "Disqualify",
        done: "%{name} disqualified",
      },
      qualify: "Qualify",
      reopen: {
        description: "The opportunity opens again in the stage you choose.",
      },
      view_kanban: "Board",
      view_list: "Table",
      empty_pipeline:
        "The pipeline is empty. Register an enquiry, or connect a form.",
      new_lead: "New lead",
    },
    settings: {
      deals: {
        high_value: "High value from (annual value)",
        high_value_help:
          "Threshold for the “High value” quick filter in Pipeline. Empty hides the filter.",
      },
    },
    shortcuts: {
      group_pipeline: "Pipeline (focused card)",
      pipeline_open: "Open opportunity",
      pipeline_next_step: "Next step",
      pipeline_move: "Next / previous stage",
      pipeline_won: "Won",
      pipeline_lost: "Lost",
      pipeline_qualify: "Qualify / disqualify (inbox)",
      pipeline_owner: "Change owner",
      pipeline_note: "Note",
      pipeline_tabs: "Tabs: Open · Won · Lost",
    },
  },
  resources: {
    deals: {
      fields: {
        offer_valid_until: "Offer valid until",
        budget_range: "Budget",
        last_activity_at: "Last activity",
        next_step_title: "Next step",
        next_step_type: "Type",
        next_step_date: "Next step date",
      },
    },
    work_items: {
      fields: {
        task_type: "Type",
        deal_id: "Opportunity",
      },
    },
  },
};
